export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Typ adresy"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Typ účtu"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Měna"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Název"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vytvořit adresu"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vytvořit účet"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vytváření nové adresy"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vytvořit nový účet"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadejte název"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyberte měnu"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vytvořit"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zrušit"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyberte typ"])}
}